import { StyledDiv, StyledContainer, StyledContent, StyledTimeline } from './styled';

interface Props {
  queryData: any;
}

export const FetchElasticSearchTimeline = ({ queryData }: Props) => {
  const replaceUnderscoreAndAt = queryData.replaceAll(/[_@]/g, '');
  const JSONData = JSON.parse(replaceUnderscoreAndAt);
  return (
    <StyledDiv>
      <StyledTimeline>
        {Array.isArray(JSONData) &&
          JSONData.sort(
            (a, b) =>
              new Date(a.source.timestamp).getTime() - new Date(b.source.timestamp).getTime(),
          )
            .slice(0, 15)
            .map((item) => {
              const connected = item.source.message.includes('Subscribed');
              return (
                <StyledContainer position={connected ? 'left' : 'right'} key={item.id}>
                  <StyledContent connected={connected}>
                    <h3>{connected ? 'Connected' : 'Disconnected'}</h3>
                    <p>{new Date(item.source.timestamp).toLocaleString('en-GB')}</p>
                  </StyledContent>
                </StyledContainer>
              );
            })}
      </StyledTimeline>
    </StyledDiv>
  );
};
